import { useSuspenseQuery } from '@tanstack/react-query';

import api from 'src/axios';
import { getSessionProductsQueryKey } from 'src/keys';

type OpenSessionProducts = {
  sku: number;
  title: string;
  criteria: string[];
}[];

export function useSessionProductsQuery(sessionId: string) {
  return useSuspenseQuery<OpenSessionProducts>({
    queryKey: getSessionProductsQueryKey(sessionId),
    queryFn: async () => {
      const { data } = await api.get<OpenSessionProducts>(
        `/sales-forecasting-sessions/${sessionId}/products`,
      );

      return data;
    },
  });
}
